import { render } from "./Chapters.vue?vue&type=template&id=02090b04&scoped=true"
import script from "./Chapters.vue?vue&type=script&lang=js"
export * from "./Chapters.vue?vue&type=script&lang=js"

import "./Chapters.vue?vue&type=style&index=0&id=02090b04&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02090b04"]])

export default __exports__